module.exports = __webpack_public_path__ + "img/keyboard-open.f39bdec5.svg";